import {
  Box,
  Breadcrumbs,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import  { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Fetching } from "../../components/Fetching";
import { ListTimesheets } from "../projects/timesheets/ListTimesheets";
import {
  useGetWorker,
  useGetTimeSheets,
  useMutateUpdateTimeSheetForWorker,
} from "./hooks";
import { StyledCard } from "../../components/StyledCard";

export const Worker = (props: any) => {
  const { id } = useParams();
  const { data, isFetching } = useGetWorker("worker", id);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('Timesheets')
  const [isExport, setIsExport] = useState(false);
  const ts = Date.now();
  const customToolBarConfig = {
    add: false,
    export: true,
    upload: false,
  };

  if (isFetching) {
    return <Fetching />;
  }

  return (
    <>
      {data ? (
        <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
          <Container maxWidth="lg">
            <Breadcrumbs aria-label="breadcrumb">
              <Link to="/dashboard"> Home </Link>
              <Link to="/workers"> Workers </Link>
              <Typography component={"span"} color="text.primary" gutterBottom>
                {data.firstName} {data.lastName}
              </Typography>
            </Breadcrumbs>

            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item xs={12} sm={8} md={8} lg={5}>
                <StyledCard>
                  <CardContent>
                    <Grid
                      container
                      sx={{
                        marginBottom: 2,
                      }}
                    >
                      <Grid
                        item
                        md={6}
                        width={"100%"}
                        sx={{ marginBottom: { xs: 2, md: 0 } }}
                      >
                        <Box sx={{ mr: 2, height: "100%" }}>
                          <img
                            src={data.idPhoto}
                            alt={data.firstName}
                            style={{
                              objectFit: "cover",
                            }}
                            height="100%"
                            width="100%"
                          />
                        </Box>
                      </Grid>
                      <Grid item md={6} width={"100%"}>
                        <Box sx={{ ml: 1.5 }}>
                          <Typography
                            variant="h5"
                            gutterBottom
                            style={{ wordBreak: "break-word" }}
                          >
                            {data.firstName} {data.lastName}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ wordBreak: "break-word" }}
                          >
                            ID # {data.idNumber}
                            <br />
                            {data.email}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </StyledCard>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12}>
              <Box sx={{ marginTop: 2 }}>
                <Typography variant="h5" gutterBottom>
                  Timesheets
                </Typography>
                <ListTimesheets
                  queryKey="workerTimesheets"
                  id={id}
                  navigate={navigate}
                  ts={ts}
                  getQuery={useGetTimeSheets}
                  updateQuery={useMutateUpdateTimeSheetForWorker}
                  showActionMenu={false}
                  customToolBarConfig={customToolBarConfig}
                  setIsExport={setIsExport}
                  selectedTab={selectedTab}
                />
              </Box>
            </Grid>
          </Container>
        </Box>
      ) : null}
    </>
  );
};
